import RelationshipDetails from "./01RelationshipDetails";
import AssetInformation from "./02AssetInformation";
// import AIChat from "./03AIChat";
import Summary from "./04Summary";

export const formSteps = {
  "1": RelationshipDetails,
  "2": AssetInformation,
  // "3": AIChat,
  "3": Summary
};
